const MINUTE_MS = 60 * 1000;

export const EXAMS_LIST_STALE_TIME = 5 * MINUTE_MS;

export const MIXED_ITEM_DIST_STALE_TIME = 2 * MINUTE_MS;

export const ACTIVE_ACCESS_CODES_STALE_TIME = 5 * MINUTE_MS;

export const PRODUCT_METADATA_STALE_TIME = 5 * MINUTE_MS;
